import { render, staticRenderFns } from "./VoegOpdrachtToeModal.vue?vue&type=template&id=3b020450&scoped=true&"
import script from "./VoegOpdrachtToeModal.vue?vue&type=script&lang=js&"
export * from "./VoegOpdrachtToeModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./VoegOpdrachtToeModal.vue?vue&type=style&index=1&id=3b020450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b020450",
  null
  
)

export default component.exports